module.exports = __webpack_public_path__ + "static/media/iStock-506288468.e54a2c5d.jpg";